import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { PopupStore } from '../stores/Popups/Popup/PopupStore';

export function useClosePopupOnNavigation(popupInstance: PopupStore): void {
  const location = useLocation();
  const initLocationRef = useRef(location);

  useEffect(() => {
    const pathnameChanged = initLocationRef.current.pathname !== location.pathname;
    const stateChanged = initLocationRef.current.state !== location.state;

    // isHidden flag means, that current popup has childs popup
    if ((pathnameChanged || stateChanged) && !popupInstance.isHidden) {
      popupInstance.close();
    }
  }, [location, popupInstance]);
}
